const auth_status = {
    page_title: 'Authentifizierungsstatus',
    title: 'Authentifizierungsstatus',
    description: 'Überprüfen Sie den Status der Authentifizierung.',
};
export default Object.freeze(auth_status);
